<template>
  <div>
    <!-- 消息列表 -->
    <message_list ref="message_list"></message_list>

    <div class="menu_box">
      <div class="dxauth_title">
        <img src="@/assets/image/auth/logo_white.png" class="auth_title_img" alt="" />
        <span class="menu_title">{{ vue_title }}</span>
      </div>

      <transition name="slide-left">
        <div class="menu_box2" v-show="!menu_loading">
          <div class="menu_box2_inner">
            <!-- 系统栏 -->
            <div class="menu_sys_list">
              <div>
                <div v-for="(item, i) in sys_list" :key="i">
                  <Tooltip :content="item.name" placement="right">
                    <div
                      v-if="vue_sys_id == item.sys_id"
                      class="menu_sys_icon_div"
                      :style="'background:' + item.color"
                    >
                      <img :src="item.img" alt="" class="sys_icon_img" />
                    </div>

                    <div v-else class="menu_sys_icon_div2" @click="click_sys(item, i)">
                      <img :src="item.img" alt="" class="sys_icon_img" />
                    </div>
                  </Tooltip>
                </div>
              </div>
            </div>

            <!-- 菜单栏 -->
            <div class="menu_list">
              <div v-for="(item, i) in menu_list" :key="i" class="menu_item">
                <div class="menu_item1">
                  <div>
                    <i
                      :class="'menu_class_parent iconfont ' + item.icon"
                      :style="'font-size:' + item.icon_size + 'px'"
                    ></i>
                    <span class="menu_class_name_parent">{{ item.name }}</span>
                  </div>
                  <div style="padding-top: 3px">
                    <Icon type="ios-arrow-down" color="#ccc" />
                  </div>
                </div>
                <div>
                  <div
                    v-for="(child_item, child_index) in item.item_list"
                    :key="child_index"
                    :class="
                      String(i) + '-' + String(child_index) == open_active
                        ? 'menu_child_select'
                        : 'menu_child'
                    "
                    @click="click_menu(item, i, child_item, child_index)"
                  >
                    <div>
                      <i
                        :class="'menu_class iconfont ' + child_item.icon"
                        :style="'font-size:' + child_item.icon_size + 'px'"
                      ></i>
                      <span class="menu_class_name">{{ child_item.name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="messag_div">
            <!-- /* 消息块 */ -->
            <div class="menu_child_div">
              <div class="oa_button" @click="click_oa_btn">
                <span class="iconfont iconoashenpi oa_img"></span>
                <span>审批</span>
              </div>
              <Badge :count="msg_count">
                <div
                  :class="
                    msg_count > 0 ? 'msg_btn_class msg_btn' : ' msg_btn_class msg_btn2'
                  "
                  @click="click_msg"
                >
                  <span class="iconfont iconxiaoxi msg_icon"></span>
                  <span class="msg_title">消息</span>
                </div>
              </Badge>
            </div>

            <div class="user_info_box">
              <div
                class="user_avatar"
                v-if="userinfo"
                @click="click_user"
                title="个人中心"
              >
                <Avatar :src="userinfo.avatar" />
                <span class="user_name">{{ userinfo.name }}</span>
              </div>
              <div class="tongzhi_div">
                <div class="exit_txt" @click="click_user">
                  <Icon type="md-power" />
                  退出登录
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- 播放音频 -->
    <audio id="notify_mp3_url" controls  v-if="notify_mp3_show">
      <source :src="notify_mp3_url"  type="audio/mpeg" />
    </audio>
  </div>
</template>

<script>
import { open_new_page, http } from "@/utils/http.js";
import { toRaw } from "vue";
import message_list from "@/views/message/index.vue";
export default {
  name: "my_menu",
  components: { message_list },
  props: [],

  data() {
    return {
      vue_sys_id: "auth_sys_95f6d45df5",
      vue_title: process.env.VUE_APP_TITLE,
      menu_show: true,
      menu_target: "_self",
      // active_name: '',
      open_active: "",
      userinfo: {},
      cut_sys_show: false,
      sys_list: [],
      menu_list: [],
      menu_loading: false,
      // 消息相关
      msg_count: 0,
      msg_intervalId: null,
      // tsy_audio: null,
      //
      oa_info: {},
      notify_mp3_url: "",
      notify_mp3_show: true,
    };
  },
  created() {
    var that = this;

    // this.tsy_audio = new Audio(require('@/assets/mp3/tsy.mp3'))
    // this.tsy_audio = new Audio();

    //获取消息数量
    that.get_msg_count();
    if (!this.msg_intervalId) {
      //获取消息数量
      this.msg_intervalId = setInterval(() => {
        //获取消息数量
        that.get_msg_count();
      }, 5000);
    }
  },
  mounted() {
    var that = this;

    // 获取用户数据
    this.get_user_data();
    // 获取菜单数据
    this.get_menu_data();
    // 获取提示音
    this.get_mp3_notify();
  },
  updated() {},

  beforeDestroy() {
    // 在组件销毁前清除定时器
    clearInterval(this.msg_intervalId);
    this.msg_intervalId = null;
  },

  watch: {
    open_active(value, oldValue) {
      // 第一个参数为新值，第二个参数为旧值，不能调换顺序
      this.menu_show = false;
      var that = this;
      setTimeout(function () {
        that.menu_show = true;
      }, 10);
    },
  },
  methods: {
    //获取消息数量
    get_msg_count() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/message/v1/message_count",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            if (that.msg_count < res.data.msg_count) {
              console.log("消息提示");
              that.msg_count = res.data.msg_count;
              that.msg_notify();
              return;
            } else {
              that.msg_count = res.data.msg_count;
            }
          } else {
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_msg() {
      this.$refs.message_list.open();
    },

    //点击用户
    click_user() {
      var url = "https://auth.daxiangsys.com/user/index/v2";
      open_new_page(url, "_blank");
    },

    click_bangzhu() {
      this.$Notice.success({
        duration: 6,
        desc: "请点击【打开DingTalkScheme】按钮，打开钉钉交流",
      });
    },

    //获取菜单与系统数据
    request_menu_data() {
      var that = this;
      this.menu_loading = true;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/auth/menu_list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.menu_list = res.data.menu_list;
            // 保存菜单信息
            localStorage.setItem("menu_list", JSON.stringify(that.menu_list));

            that.sys_list = res.data.sys_list;
            // 保存系统列表
            localStorage.setItem("sys_list", JSON.stringify(that.sys_list));

            that.oa_info = res.data.oa_info;

            // 更新菜单选项
            that.update_menu();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.menu_loading = false;
        })
        .catch((res) => {
          that.menu_loading = false;
          console.log(res, "请求出错");
        });
    },

    //获取通知音乐
    get_mp3_notify() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_MESSAGE_URL + "/message/notify_mp3", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.notify_mp3_url = res.data.mp3_url;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          that.menu_loading = false;
          console.log(res, "请求出错");
        });
    },

    get_user_data() {
      var userinfo = this.$cookies.get("dx_user_info");
      if (userinfo != "undefined") {
        this.userinfo = userinfo;
      }
    },

    // 获取菜单数据
    get_menu_data() {
      // 获取菜单数据
      this.request_menu_data();
    },

    on_select(e) {
      var select_menu = e.split("-");
      var current_item = toRaw(
        this.menu_list[Number(select_menu[0])]["item_list"][Number(select_menu[1])]
      );
      // if(current_item.is_lock){
      //   this.menu_list[Number(select_menu[0])]['item_list'][Number(select_menu[1])]['path'] = '/page_403'
      // }
    },

    //更新菜单选中列
    update_menu() {
      var current_path = this.$route.path;
      var ment_list = toRaw(this.menu_list);
      if (!ment_list) {
        return;
      }

      for (let i = 0; i < ment_list.length; i++) {
        var menu_item = toRaw(this.menu_list[i]);
        for (let x = 0; x < menu_item["item_list"].length; x++) {
          if (menu_item["item_list"][x]["path"] == current_path) {
            // this.active_name = x
            this.open_active = String(i) + "-" + String(x);
            return;
          }
        }
      }
    },

    //点击切换系统
    click_sys(item, i) {
      if (item.sys_auth) {
        var url = item.url;
        open_new_page(url, "_blank");
      } else {
        this.$Message.error("没有这个系统登录权限");
      }
    },

    //确认退出
    quit_button() {
      this.$cookies.remove("dx_token");
      this.$cookies.remove("dx_private_key");
      this.$cookies.remove("dx_public_key");
      this.$cookies.remove("dx_user_info");

      var login_url = process.env.VUE_APP_LOGIN_URL;
      var auth_url = process.env.VUE_APP_AUTH_URL;
      var url = auth_url + "/?redirect_url=" + login_url;
      open_new_page(url, "_self");
    },

    //点击菜单
    click_menu(item, i, child_item, child_index) {
      this.open_active = String(i) + "-" + String(child_index);
      open_new_page(child_item.path, "_self");
    },

    msg_notify() {
      var that = this;

      // 显示通知条
      // this.$Notice.open({
      //   duration:5,
      //   desc: '<i class="iconfont iconxiaoxi " style="color:#0073ff;font-size:22px;margin-right:5px"></i> 您有一条新消息，点击消息查看！',
      //   onClose: function () {

      //   }
      // });
      // 播放音乐

      // this.notify_mp3_show = false;
      // setTimeout(function () {
      //   that.notify_mp3_show = true;
       
      // }, 100);

      // setTimeout(function () {
      //   var audioElement = document.getElementById("notify_mp3_url");
      //   audioElement.play().catch((error) => {
      //     console.log(error);
      //     console.log("通知声音没有播放");
      //   });
      // }, 500);

      // this.tsy_audio.play().catch((error) => {
      //   console.log(error);
      // });
    },

    click_oa_btn() {
      var url = "https://oa.daxiangsys.com/home";
      open_new_page(url);
    },
  },
};
</script>

<style scoped>
#notify_mp3_url {
  display: none;
}

.xiaoxinotice {
  font-size: 20px;
  color: #0073ff;
}

.oa_img {
  font-size: 14px;
  margin-right: 5px;
  color: #ff4400;
}

.oa_button:hover {
  background-color: #f8e9e6;
}

.oa_button {
  width: 70px;
  background-color: #fff;
  padding: 5px;
  border-radius: 50px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 8px 0 10px;
}

.menu_sys_buttom {
  height: 100px;
  position: absolute;
  bottom: 0px;
  width: 40px;
}

.menu_sys_icon_div {
  width: 35px;
  height: 35px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 0 0 2px #c9c6c6;
}

.menu_sys_icon_div2 {
  width: 35px;
  height: 35px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  cursor: pointer;
  background: #ececec;
  border: 1px solid #edecec;
}

.menu_sys_icon_div2:hover {
  background: #0466dd;
}

.menu_sys_list {
  padding: 15px 0 0 5px;
  width: 48px;
  background-color: #fff;
  border-right: 1px solid #f7f3f3;
  flex-shrink: 0;
  height: calc(100vh - 170px);
  overflow: auto;
}

.menu_sys_list::-webkit-scrollbar {
  width: 0;
}

.menu_title {
  font-size: 14px;
}

.menu_class_name {
  font-size: 13px;
  cursor: pointer;
}

.menu_class_name_parent {
  font-size: 13px;
  color: #b3b5b6;
  cursor: pointer;
}

.menu_child:hover {
  background-color: #eef3f9;
}

.menu_child {
  padding: 5px 0 5px 15px;
  color: #616a74;
}

.menu_child_select {
  padding: 5px 0 5px 15px;
  background: #0466dd;
  color: #fff;
}

/* .menu_item1:hover {
  background-color: #eef3f9;
} */

.menu_item1 {
  padding: 5px 10px 5px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.menu_item {
  cursor: pointer;
  margin-bottom: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid #f7f3f3;
}

.menu_class {
  margin-right: 8px;
}

.menu_class_parent {
  margin-right: 8px;
  color: #b3b5b6;
}

/* 消息块 */
.msg_icon {
  font-size: 14px;
  margin-right: 5px;
  color: #0073ff;
}

.msg_title {
  font-size: 13px;
  color: #847c7c;
}

.msg_btn:hover {
  background-color: #e8f3ff;
}

.msg_btn2:hover {
  background-color: #e8f3ff;
}

.msg_btn {
  padding: 5px;
  background-color: #fff;
  color: #333;
  width: 70px;
  border-radius: 30px;
  text-align: center;
}

.msg_btn2 {
  padding: 6px 5px;
  background-color: #fff;
  color: #333;
  width: 70px;
  border-radius: 30px;
  text-align: center;
}

.menu_child_div {
  display: flex;
  align-items: center;
  background: #d0e5ff;
  cursor: pointer;
  height: 50px;
}

.menu_child_div:hover {
  background: #0073ff;
}

/* 消息块 */
.sys_lock_icon {
  font-size: 26px;
  position: absolute;
  color: #093366;
}

.sys_icon_img {
  width: 20px;
  height: 20px;
}

.bangzhu {
  margin-right: 10px;
  color: #888;
  font-size: 13px;
}

.bangzhu:hover {
  color: #3482e1;
}

.menu_list {
  padding-top: 5px;
  height: calc(100vh - 170px);
  overflow: auto;
  width: 122px;
  overflow: auto;
  background-color: #fff;
}

.menu_list::-webkit-scrollbar {
  width: 0;
}

.auth_title_img {
  width: 25px;
  height: 25px;
  margin-right: 5px;
}

.messag_div {
  background-color: #fff;
}

.menu_box2 {
  width: 170px;
}

.menu_box2_inner {
  display: flex;
}

.lock_menu {
  position: absolute;
  right: 5px;
  line-height: 30px;
}

/* 切换系统 */

.drawer_class {
  border-radius: 0 0 100px 100px;
}

.sys_cut_box {
  text-align: center;
  margin: 10px 15px 0 15px;
  cursor: pointer;
}

.sys_cut_list {
  display: flex;
  flex-wrap: wrap;
}

.cut_title {
  margin: 10px 20px;
  font-size: 13px;
  border-radius: 199px;
  font-weight: 300;
  background-color: #f7f7f7;
  background: #0466dd;
  border: 1px solid rgb(236, 236, 236);
  color: rgb(255, 255, 255);
  height: 36px;
  line-height: 33px;
  text-align: center;
  position: relative;
  top: -10px;
  flex-shrink: 0;
}

.cut_sys_box {
}

.sys_img_detail {
  font-size: 13px;
  color: #ccc;
  margin-top: 5px;
  text-align: center;
}

.sys_img_detail_select {
  color: #333;
  font-size: 14px;
  margin-top: 10px;
  font-weight: 600;
  text-align: center;
  display: flex;
  justify-content: center;
}

.sys_img_box {
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  color: #fff;
  border: 2px solid #fff;
  position: relative;
}

.sys_img_box:hover {
  border: 2px solid #ddd;
}

.sys_img_box2 {
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  color: #909090;
  background: #ccc;
  border: 2px solid #fff;
  position: relative;
}

.cut_menu {
  margin-left: 10px;
  cursor: pointer;
  font-weight: 300;
  font-size: 18;
}

/*  */

/* 用户信息栏 */

.exit_txt_detail {
  margin-bottom: 10px;
}

.affirm_quit_btn_box {
  display: flex;
  justify-content: flex-end;
}

.affirm_quit_btn {
  background: #c90202;
  color: #fff;
  width: 60px;
  text-align: center;
  border-radius: 3px;
  font-size: 12px;
  padding: 3px 5px;
  cursor: pointer;
}

.exit_txt {
  color: #888;
  cursor: pointer;
  font-size: 13px;
}

.exit_txt:hover {
  color: #ff0000;
}

.user_name {
  margin-left: 10px;
  font-weight: 400;
}

.user_avatar:hover .user_name {
  font-weight: 600;
  color: #0466dd;
}

.user_avatar {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.tongzhi_div {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.user_info_box {
  height: 70px;
  padding: 10px;
  border-top: 1px solid #ececec;
}

/* 用户信息栏end */

.menu_box {
  height: 100vh;
  width: 170px;
}

.dxauth_title {
  letter-spacing: 3px;
  font-weight: 600;
  font-size: 14px;
  width: 100%;
  text-align: center;
  height: 50px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: #0466dd;
}
</style>
